<template>
	<div>
		<div id="content-wrapper">
      <car-list></car-list>
			<main-map></main-map>
		</div>
		<grafico-velocidad id="footer" class="speedChart"></grafico-velocidad>
	</div>
</template>

<script>
import GraficoVelocidad from './GraficoVelocidad'
import CarList from './CarList'
import MainMap from './MainMap'

export default {
	components: {
		MainMap,
		CarList,
		GraficoVelocidad
	},
	data() {
		return {
			contentHeight: Number
		}
	},
	mounted() {
		window.addEventListener('resize', this.handleResize)
		this.handleResize();
	},
	destroyed() {
		let windowHeight = window.innerHeight
		document.getElementById("sidebar").style.height = windowHeight + 'px'
		window.removeEventListener('resize', this.handleResize)
	},
	methods: {
		handleResize() {
			let navbarHeight = document.getElementById("navbar").offsetHeight
			let footerHeight = document.getElementById("footer").offsetHeight
			let sidebarWidth = document.getElementById("sidebar").offsetWidth

			let windowHeight = window.innerHeight
			let windowWidth = window.innerWidth

			this.contentHeight = windowHeight - navbarHeight - footerHeight
			let sidebarHeight = windowHeight - footerHeight
			this.footerWidth = windowWidth

			document.getElementById("content-wrapper").style.height = this.contentHeight + 'px'
			document.getElementById("footer").style.width = this.footerWidth + 'px'
			document.getElementById("sidebar").style.height = sidebarHeight + 'px'
		}
  	}
}
</script>

<style lang="scss">
	#content-wrapper {
		position: relative;
	}
	.speedChart {
		position: fixed;
		height: 155px;
		clear: both;
		// bottom: 0;
		left: 0;
		bottom: 0;
		background: #212120;
		border-top: 2px solid;
		border-color: #bebebe;
	}

</style>
